class ProductGalleryModal extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('dialog#product-gallery-modal');
    this.closeButton = this.querySelector('button#close-gallery-modal');

    this.slider = this.querySelector('swiper-container#product-gallery-modal');
    this.thumbsSlider = this.querySelector('swiper-container#product-gallery-modal-thumbs');

    this.mediaQueryList = window.matchMedia('(width < 768px)');

    this.firstTimeOpening = true;

    this.handleClose = this.close.bind(this);
    this.handleUpdateSliderDirection = this.updateSliderDirection.bind(this);
    this.handleSlideZoom = this.toogleZoom.bind(this);
  }

  connectedCallback() {
    this.closeButton.addEventListener('click', this.handleClose);
    this.modal.addEventListener('close', this.handleClose);
    this.mediaQueryList.addEventListener('change', this.handleUpdateSliderDirection);
    this.slider.addEventListener('swipertap', this.handleSlideZoom);

    this.handleUpdateSliderDirection(this.mediaQueryList);
  }

  disconnectedCallback() {
    this.closeButton.removeEventListener('click', this.handleClose);
    this.modal.removeEventListener('close', this.handleClose);
    this.mediaQueryList.removeEventListener('change', this.handleUpdateSliderDirection);
    this.slider.removeEventListener('swipertap', this.handleSlideZoom);
  }

  updateSliderDirection(mediaQueryList) {
    if (this.thumbsSlider) {
      this.thumbsSlider.swiper.changeDirection(mediaQueryList.matches ? 'horizontal' : 'vertical', true);
    }

    // The zoom option is not enable in mobile viewports.
    if (mediaQueryList.matches) {
      this.slider.removeEventListener('swipertap', this.handleSlideZoom);

      try {
        this.slider.swiper.zoom.out();
      } catch {
        console.error("Zoom module couldn't be enabled");
      }
    } else {
      this.slider.addEventListener('swipertap', this.handleSlideZoom);
    }
  }

  toogleZoom(event) {
    const [re] = event.detail;

    try {
      re.zoom.toggle();
    } catch {
      console.error("Zoom module couldn't be enabled");
    }
  }

  close() {
    document.body.style.overflow = 'auto';
    document.documentElement.style.overscrollBehaviorX = 'auto';
    document.documentElement.style.touchAction = 'auto';

    try {
      this.slider.swiper.zoom.out();
    } catch {
      console.error("Zoom module couldn't be enabled");
    }

    this.modal.close();
  }

  open(index = 0) {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overscrollBehaviorX = 'contain';
    document.documentElement.style.touchAction = 'pan-y';

    this.slider.swiper.slideTo(index || 0);

    this.modal.showModal();

    // This fixes an issue where the class for the current active thumb is not enable and thus we
    // need to force an update. We only do this the first time.
    if (this.firstTimeOpening && this.thumbsSlider) {
      this.thumbsSlider.swiper.update();
      this.firstTimeOpening = false;
    }
  }
}

if (!customElements.get('product-gallery-modal')) {
  customElements.define('product-gallery-modal', ProductGalleryModal);
}
